// extracted by mini-css-extract-plugin
export default {"supportSection":"SupportSection__supportSection__ajFNR","fixedImage":"SupportSection__fixedImage__mENLc","list":"SupportSection__list__OFaO8","animationDelay":"SupportSection__animationDelay__aTYtt","itemImg":"SupportSection__itemImg__nwslv","gridList":"SupportSection__gridList__TH6M4","listText":"SupportSection__listText__sRvjx"};
    if(module.hot) {
      // 1753447560855
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  